<template>
  <div class="wrap" @click="hideSetMask()">
    <div class="zl-content account">
      <div class="zl-form">
        <div style="margin-top: 100px; position: relative;">
          <!-- <img v-if="imgshow" src="static/logo-xg.png" alt />
          <img v-if="!imgshow" src="static/logo-en-xg.png" alt="" /> -->
          <img v-if="imgshow" src="static/logo.png" alt />
          <img v-if="!imgshow" src="static/logo-en.png" alt="" />
          <div class="local" @click="langchange(lang)">
            {{ lang === 'zh' ? 'English' : '中文' }}
          </div>
        </div>
        <div class="form-item">
          <input type="text" v-model="unm" :placeholder="$t('login.用户名')" />
        </div>
        <div class="form-item">
          <input type="password" v-model="pwd" :placeholder="$t('login.密码')" />
        </div>
        <div class="form-item" v-if="false">
          <el-select :no-data-text="$t('home.noData')" v-model="lang" @change="langchange" :placeholder="$t('login.请选择')">
            <el-option :label="$t('login.中文')" value="zh"></el-option>
            <el-option :label="$t('login.英文')" value="en"></el-option>
          </el-select>
        </div>

        <!-- <div v-loading="loading"
          element-loading-text="loading"
          element-loading-spinner="el-icon-loading"
        element-loading-background="  rgba(19, 15, 15, 0.1)"></div>-->
        <div class="form-item">
          <button class="zl-submit" @click="submit" v-loading.fullscreen.lock="fullscreenLoading" type="button">{{ $t('login.登录') }}</button>
          <button class="zl-submit" @click="dialogFormVisible = true" type="button">{{ $t('login.注册') }}</button>
        </div>
      </div>
    </div>
    <el-dialog width="500px" :title="$t('login.用户注册')" :center="true" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item :label="$t('login.用户名')" :required="true" :label-width="formLabelWidth">
          <el-input v-model="form.unm" auto-complete="off" class="inputwid"></el-input>
        </el-form-item>
        <el-form-item :label="$t('login.手机号')" :required="true" :label-width="formLabelWidth">
          <el-input v-model="form.phone" auto-complete="off" class="inputwid"></el-input>
        </el-form-item>
        <el-form-item :label="$t('login.密码')" :required="true" :label-width="formLabelWidth">
          <el-input type="password" v-model="form.pwd" auto-complete="off" class="inputwid"></el-input>
        </el-form-item>
        <div class="allyzm">
          <div>
            <el-form-item :label="$t('login.验证码')" :required="true" :label-width="formLabelWidth">
              <div class="inputla">
                <el-input v-model="form.valcode" auto-complete="off" class="inputwid1"></el-input>
              </div>
            </el-form-item>
          </div>
          <div class="btnyzm">
            <button type="button" @click="getCode()" class="code-btn" :disabled="!show">
              <span v-show="show">{{ $t('login.获取验证码') }}</span>
              <span v-show="!show" class="count">{{ count }} s</span>
            </button>
          </div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">{{ $t('login.取消') }}</el-button>
        <el-button type="primary" @click="regist()">{{ $t('login.确定') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import mixin from '../utils'
import { register, login, sendcode } from '../service/getData'
import { setToken, setUser } from '../utils/auth'
import locale from 'element-ui/lib/locale'
import en from 'element-ui/lib/locale/lang/en'
import zh from 'element-ui/lib/locale/lang/zh-CN'
const TIME_COUNT = 60
export default {
  name: 'app',
  mixins: [mixin],
  data() {
    return {
      fullscreenLoading: false,
      // loading: false,
      lang: 'zh',
      selected: 1,
      showSetMask: false,
      form: {
        unm: null,
        phone: null,
        pwd: null,
        valcode: null
      },
      dialogTableVisible: false,
      dialogFormVisible: false,
      formLabelWidth: '100px',
      Authorization: '',

      unm: null,
      pwd: null,
      code: null,

      show: true,
      count: '',
      timer: null,
      imgshow: true,
      optionszh: [
        {
          label: 'GoogleMap',
          value: 2
        },
        {
          label: 'Show Satellite Map',
          value: 1
        },
        {
          label: 'China Gaode Map',
          value: 3
        }
      ],
      optionsen: [
        {
          label: '谷歌地图',
          value: 2
        },
        {
          label: '显示卫星图',
          value: 1
        },
        {
          label: '高德地图',
          value: 3
        }
      ]
    }
  },
  mounted() {
    this.lang = localStorage.getItem('lang') || 'zh'
    // this.langchange(this.lang)
    this.$i18n.locale = this.lang
    if (this.lang === 'zh') {
      this.imgshow = true
      locale.use(zh)
      console.log('zh ===>')
    } else {
      console.log('en ===>')
      locale.use(en)
      this.imgshow = false
    }
  },
  methods: {
    langchange(lang) {
      if (lang === 'zh') {
        this.lang = 'en'
        this.imgshow = false
        locale.use(en)
      } else {
        this.lang = 'zh'
        this.imgshow = true
        locale.use(zh)
      }

      this.$i18n.locale = this.lang
      if (this.$i18n.locale == 'zh') {
        document.title = this.$t('home.title')
        // localStorage.setItem('options', JSON.stringify(this.optionszh) )
      } else {
        document.title = this.$t('home.title')
        // localStorage.setItem('options', JSON.stringify(this.optionsen) )
      }
    },
    async regist() {
      // if (unm && pwd && code == form.valcode) {
      // } else {
      //   this.$message({
      //     message: '验证信息不通过，新重新录入',
      //     type: 'error'
      //   })
      // }
      let result = await register(this.form.unm, this.form.pwd, this.form.phone, this.form.valcode)
      let data = result.data
      if (data.ResultType == 0) {
        this.$message({
          message: data.Message,
          type: 'success'
        })
        setToken(data.AppendData)
        setUser(this.form.unm)
        this.$router.push({ path: 'home' })
      } else {
        this.$message({
          message: data.Message,
          type: 'error'
        })
      }
    },
    async submit() {
      // if (this.unm === 'user01') {
      //   document.querySelector('#app').innerHTML = ''
      //   return
      // }
      // 设备绑定
      const localtoken = localStorage.getItem('localtoken') || ''

      this.fullscreenLoading = true
      let result
      try {
        result = await login(this.unm, this.pwd, localtoken)
        let data = result.data

        if (data.ResultType == 0) {
          this.$message({
            message: this.$t('home.登录成功'),
            type: 'success'
          })
          setToken(data.AppendData)
          setUser(this.unm)
          localStorage.setItem('lang', this.lang)
          // 存在uuid时，存储待用；
          data.AppendData.card && localStorage.setItem('localtoken', data.AppendData.card)
          this.$router.push({ path: 'home' })
        } else {
          this.$message({
            message: this.$t('home.登录失败'),
            type: 'error'
          })
        }
        this.fullscreenLoading = false
      } catch (error) {
        this.fullscreenLoading = false
      }
    },
    async getCode() {
      if (!this.timer) {
        this.count = TIME_COUNT
        this.show = false
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--
          } else {
            this.show = true
            clearInterval(this.timer)
            this.timer = null
          }
        }, 1000)

        let result = await sendcode(this.form.phone)

        let data = result.data
        if (result.data.Message === 'OK') {
          this.$message({
            message: data.Message,
            type: 'success'
          })
        } else {
          this.$message({
            message: data.Message,
            type: 'error'
          })
        }
        this.code = data
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.wrap {
  background-image: linear-gradient(-225deg, #205d86 0%, #106f9d 100%);
  height: 100vh;
  overflow-y: auto;
}

.code-btn {
  height: 32px;
  margin-left: 14px;
}

.inputwid {
  width: 300px;
}

.inputwid1 {
  width: 200px;
}

.allyzm {
  display: flex;
}

.zl-content {
  &.account {
    padding: 15px;

    .zl-form {
      width: 90%;
      margin: 0 auto;

      text-align: center;

      .local {
        position: absolute;
        right: 0;
        top: 0;
        color: white;
        cursor: pointer;
      }

      .form-item {
        margin-top: 30px;

        ::-webkit-input-placeholder {
          color: rgba(255, 255, 255, 0.5);
        }

        input {
          border: 1px solid rgba(19, 15, 15, 0.1);
          background: rgba(255, 255, 255, 0.1);
          border-radius: 4px;
          padding: 15px;
          width: 80%;
          color: white;

          &.inputValidat {
            width: 40%;
          }
        }

        button {
          border: 1px solid rgba(255, 255, 255, 0.5);
          padding: 15px;
          width: 39%;

          color: white;
          background: rgba(0, 0, 0, 0.1);
        }

        .zl-submit {
          /* Rectangle 2: */
          background: #126c99;
          border-radius: 4px;
          color: white;
          width: 280px;
        }
      }
    }
  }
}

// .loading {
//   width: 300px;
//   height: 80px;
//   background-color: darkslategrey;
// }
</style>
